import './WebsiteLeadsFilterPage.css'
import { useNavigate } from 'react-router-dom'
import { Row, Col } from 'react-bootstrap'
import { DcsPermissions, GridCellEnum, ICustomColumn, IPageProps } from 'types'
import { AddButton, PageHeader } from 'components'
import { V1ApiIntegrationsClient } from 'core/http-common'
import { useState } from 'react'
import toast from 'core/toast'
import SAGrid, { GridGetDataProps, GetDataResponse } from 'components/Grid/SAGrid'
import { GridRowClickEvent } from '@progress/kendo-react-grid'
import { anyPermissionsRedirect } from 'core/helpers'
import { IWebLeadFilterDto } from 'generated/v1/v1IntegrationsApi'
import { getDeleteType } from 'core/helpers'
import { hasPermission } from 'state/reduxHelpers'

export interface IDropDownStringValue {
    id: string,
    text: string
}

const WebsiteLeadsFilterPage = ({ title }: IPageProps) => {

    const navigate = useNavigate()

    const [loaded, setLoaded] = useState(false)

    const filterColumns: ICustomColumn[] = [
        { field: 'dealerId', title: 'Dealer ID' },
        { field: 'firstName', title: 'First Name' },
        { field: 'lastName', title: 'Last Name' },
        { field: 'phone', title: 'Phone' },
        { field: 'mobilePhone', title: 'Mobile Phone' },
        { field: 'email', title: 'Email' },
        { field: 'ipAddress', title: 'IP Address' },
        { field: 'action', title: 'Delete', sortable: false, headerClassName: 'text-center', width: '80px', cellType: GridCellEnum.DeleteAction }
    ]

    const rowClicked = (e: GridRowClickEvent) => {
        anyPermissionsRedirect([DcsPermissions.EditSpamFilter], `/integrations/website-leads-filter/edit/${e.dataItem.webLeadFilterId}`, navigate)
    }

    const fetch = async (props: GridGetDataProps): Promise<GetDataResponse> => {
        try {
            const result = await V1ApiIntegrationsClient.getWebLeadFilters(
                props.search,
                props.sortBy,
                props.sortAscending,
                props.paging && props.paging.currentPage ? props.paging.currentPage : 1,
                props.paging ? props.paging.take : 50,
            )
            setLoaded(true)
            return {
                data: result.data,
                total: result.totalItems ? result.totalItems : 0
            }
        }
        catch (e) {
            toast.responseErrors(e)
            return {
                data: [],
                total: 0
            }

        }
    }

    const deleteItem = async (item: IWebLeadFilterDto) => {
        await V1ApiIntegrationsClient.deleteWebLeadFilter(item.webLeadFilterId)
        toast.success('Web Leads Filter deleted successfully')
    }

    const deleteMessage = (item: IWebLeadFilterDto) => {
        if (item) {
            return <div>Are you sure you want to delete the Leads filter for dealer Id <b>{item.dealerId}</b>?</div>
        }
    }

    return (
        <div id='WebsiteLeadsFilterPage'>
            <PageHeader title={title}>
                <AddButton 
                    className='btn-lg btn-primary btnWidth mb-2 mb-md-0' 
                    onClick={() => anyPermissionsRedirect([DcsPermissions.AddSpamFilter], '/integrations/website-leads-filter/add', navigate)}>
                    Add Filter
                </AddButton>
            </PageHeader>

            <Row>
                <Col>
                    <SAGrid
                        features={
                            {
                                sortable: true,
                                pageable: true,
                                reorderColumns: true,
                                simpleSearch: true
                            }
                        }
                        columns={filterColumns}
                        defaultSort={[{ field: 'firstName', dir: 'desc' }]}
                        getData={fetch}
                        onRowClick={rowClicked}
                        deleteAction={{
                            handler: deleteItem,
                            canDelete: true,
                            deleteTitle: 'Delete Filter Confirmation',
                            getDeleteMessage: deleteMessage,
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            getItemDeleteType: (item: IWebLeadFilterDto) => getDeleteType(hasPermission(DcsPermissions.DeleteSpamFilter), item.webLeadFilterId, false)
                        }}
                    />
                </Col>
            </Row>
        </div>
    )
}
export default WebsiteLeadsFilterPage